import { Tooltip } from '../../popover/tooltip';
import { StatusCell } from '../../status/status-cell';

type Props = {
  /** Optional override for the tooltip body. Defaults to the catalog-fix message. */
  tooltip?: string;
};

const DEFAULT_TOOLTIP =
  "Missing case quantity. Sales velocity and deal savings can't be calculated for this product — update the case quantity in the product catalog to fix.";

export function MissingCaseQtyBadge({ tooltip = DEFAULT_TOOLTIP }: Props) {
  return (
    <Tooltip content={tooltip}>
      <StatusCell variant="attention" tone="soft">
        ⚠ —
      </StatusCell>
    </Tooltip>
  );
}
